export { isCustomUIExtension, isUIKit2Extension } from './forge-ui';
